import { PDFDownloadLink } from '@react-pdf/renderer'
import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'react-bootstrap'
import 'react-toggle/style.css'
import CustomButton from '../../../components/Button/CustomButton'
import '../../../styles/style.css'
import Pdf from '../../Download/Pdf'

function ModalTypeDownloadRack(props) {
  const [typeValue, setTypeValue] = useState('slot')
  const [showDownloadPdf, setShowDownloadPdf] = useState(false)

  const handleTypeChange = (type) => {
    setTypeValue(type)
  }
  const shardingItems = () => {
    const data = props.slots.reduce((acc, item) => {
      acc.push({
        id: item.id,
        name: item.code,
        qr: item.qr
      })
      return acc
    }, [])
    const shardedData = []

    for (let i = 0; i < data.length; i += 2) {
      shardedData.push(data.slice(i, i + 2))
    }
    return shardedData
  }
  const fileNameLabel = useMemo(() => {
    return typeValue === 'beam' ? 'print_qr_beam.pdf' : 'print_qr_slot.pdf'
  }, [typeValue])

  useEffect(() => {
    if (showDownloadPdf) {
      const timer = setTimeout(() => {
        setShowDownloadPdf(false)
        props.onHide()
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [showDownloadPdf, props])

  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>Print All QR</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <div className="form-check d-flex flex-row gap-3 mb-3">
            <input
              className="staging-area form-check-input"
              type="radio"
              name="type"
              id="Beam"
              checked={typeValue === 'beam'}
              onChange={() => handleTypeChange('beam')}
            />
            <div className="d-flex flex-column justify-content-center align-items-center">
              <label
                className="form-check-label fs-6 mt-1 fw-bold"
                htmlFor="Beam"
              >
                Beam
              </label>
            </div>
          </div>
          <div className="form-check d-flex flex-row gap-3 mb-3">
            <input
              className="staging-area form-check-input"
              type="radio"
              name="type"
              id="slot"
              checked={typeValue === 'slot'}
              onChange={() => handleTypeChange('slot')}
            />
            <div className="d-flex flex-column justify-content-center align-items-center">
              <label
                className="form-check-label fs-6 mt-1 fw-bold"
                htmlFor="slot"
              >
                Slot
              </label>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="mt-3">
        <div className="d-flex w-100 justify-content-end flex-row">
          {typeValue === '' && (
            <CustomButton
              variant={'secondary'}
              text={'Print'}
              disabled={true}
            />
          )}
          {typeValue !== '' && (
            <PDFDownloadLink
              document={<Pdf data={shardingItems()} typeDownload={typeValue} />}
              fileName={fileNameLabel}
              onClick={() => {
                setShowDownloadPdf(true)
              }}
            >
              {({ loading }) => (
                <CustomButton
                  variant={typeValue === '' ? 'secondary' : 'warning'}
                  text={
                    loading && showDownloadPdf
                      ? 'Preparing...'
                      : showDownloadPdf
                        ? 'Download'
                        : 'Print'
                  }
                  disabled={typeValue === '' || loading}
                />
              )}
            </PDFDownloadLink>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  )
}
export default ModalTypeDownloadRack
